import { CREDENTIALS_ROTATION_DAYS } from "../../../constants/organizations";

// Formats an ISO status date as "June 5, 2026" to match the design copy.
// Returns null for missing or unparseable dates so callers can render the
// status pill alone instead of "Invalid Date".
export const formatStatusDate = (isoDate: string | null | undefined): string | null => {
  if (!isoDate) return null;
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

// "123,182" — grouped number for the summary cards; falls back to a dash while
// stats are loading or unavailable.
export const formatStatValue = (value: number | null | undefined): string =>
  typeof value === "number" ? value.toLocaleString("en-US") : "–";

// Display name for an org whose name may be missing in legacy data (the v3
// accessible-organizations list returns null names on some rows), so pickers
// and tables never render a blank row or crash on a null name.
export const getOrganizationName = (organization: { id: number; name: string | null }): string =>
  organization.name?.trim() || `Organization #${organization.id}`;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

// Whether an org's client secret is due for rotation: never rotated through the
// API (null), an unparseable date, or older than CREDENTIALS_ROTATION_DAYS.
// `now` is injectable for tests.
export const isCredentialRotationOverdue = (
  lastRotatedAt: string | null | undefined,
  now: Date = new Date()
): boolean => {
  if (!lastRotatedAt) return true;
  const rotated = new Date(lastRotatedAt);
  if (isNaN(rotated.getTime())) return true;
  return now.getTime() - rotated.getTime() > CREDENTIALS_ROTATION_DAYS * MS_PER_DAY;
};
